import store from "redux/store";
import { AAD_LOGIN_SUCCESS } from "actions/types";
import { resolveEffectiveRole } from "helpers/role";

export async function setCurrentUserState(
  initialized: boolean,
  keycloak: any,
  currentUserDetails: any
) {
  try {
    if (initialized && keycloak && currentUserDetails) {
      const keycloakClientId = process.env.REACT_APP_KEYCLOAK_CLIENT_ID;
      const clientRoles =
        // @ts-ignore
        keycloak.tokenParsed?.resource_access?.[keycloakClientId]?.roles || [];
      store.dispatch({
        type: AAD_LOGIN_SUCCESS,
        payload: {
          account: {
            initialized: initialized,
            authenticated: keycloak.authenticated,
            localAccountId: keycloak.tokenParsed?.sub,
            username: keycloak.tokenParsed?.preferred_username,
            name: keycloak.tokenParsed?.name,
            idTokenClaims: {
              role: resolveEffectiveRole(clientRoles),
              isVerified: currentUserDetails.isVerified,
              companyId: currentUserDetails.companyId,
              termsVersion: currentUserDetails?.termsVersion,
            },
          },
        },
      });
    }
  } catch (err) {
    console.error(err);
  }
}
